export default (opts = {}) => {
    const component = {
        model: {
            defaults: {
                type: 'Container',
                name: 'Container Depoimentos',
                attributes: { class: 'container-cubo' },
                components: [
                   {
                    type: 'columnsTestimony5'
                   }
                ],
                styles: `
              
               .container-cubo{
                max-width: 1600px; 
             }
            `,
            },
        },
        view: {

        },
    };
    return component;
};